import { Error as WebApiError } from "WebServices/APIs/self/models/V1/Common/Error";
import { Error as AdminApiError } from "AdminServices/APIs/self/models/V1/Common/Error";
export const isApiError = (error) => {
  return error instanceof WebApiError || error instanceof AdminApiError;
};
